import { Pill } from "@/components/podkit/status/Pill";
import { getPhaseInfo } from "@/components/runners/runner-labels";
import type { PlainRunner } from "@/queries/runner-queries";
import { type RunnerPhase } from "gitpod-next-api/gitpod/v1/runner_pb";
import { type FC, useMemo } from "react";

export const RunnerPhaseTag: FC<{ runner: PlainRunner; labelOverrides?: Partial<Record<RunnerPhase, string>> }> = ({
    runner,
    labelOverrides,
}) => {
    const { variant, name, tooltip } = useMemo(() => {
        const info = getPhaseInfo(runner);
        const name = (info.matchedPhase !== undefined && labelOverrides?.[info.matchedPhase]) || info.label;
        return { variant: info.variant, name, tooltip: info.tooltip };
    }, [runner, labelOverrides]);

    return (
        <Pill variant={variant} tooltip={tooltip}>
            {name}
        </Pill>
    );
};
